import {
  createService,
  getPaginatedResponseSchema,
  z,
} from '@betty/toolkit/api';
import { PromoSchema } from './PromosService.schemas';

export const anonPromosService = createService({
  getPublicPromos: {
    method: 'GET',
    url: '/Lobby/promotions',
    responseSchema: getPaginatedResponseSchema(PromoSchema),
  },
});

export const userPromosService = createService(
  {
    getPromos: {
      method: 'GET',
      url: '/promotions',
      responseSchema: getPaginatedResponseSchema(PromoSchema),
    },
    optIn: {
      method: 'POST',
      url: ({ promoId }: { promoId: number }) => `/promotions/${promoId}/optin`,
      responseSchema: z.object({}).optional(),
    },
    optOut: {
      method: 'POST',
      url: ({ promoId }: { promoId: number }) =>
        `/promotions/${promoId}/optout`,
      responseSchema: z.object({}).optional(),
    },
  },
  ({ userId }) => `/Players/${userId}`,
);

export default {
  ...anonPromosService,
  ...userPromosService,
};
